import { trackCheckoutProgress } from '../../../../../../shared/analytics/e-commerce/trackCheckoutProgress';
import { CheckoutSteps } from './CheckoutSteps';

export function trackViewSearch() {
	trackCheckoutProgress({ step: CheckoutSteps.SelectDates });
}
